import Cookies from 'js-cookie';

export const getCurrentLanguage = () => Cookies.get('language') || Cookies.get('loginLng');
